import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateRepresentante } from './can-activate-representante';
import { RepresentanteComponent } from './representante.component';
import { RepresentanteFormComponent } from './form';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateRepresentante],
                children: [
                    {path: '', component: RepresentanteComponent},
                    // {path: 'novo', component: RepresentanteFormComponent},
                    {path: ':id', component: RepresentanteFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateRepresentante
    ]
})
export class RepresentanteRoutingModule { }
